export enum SuggestionResult {
  SUCCESS = "Success",
  FAILURE = "Failure"
}
